<template>
  <v-container grid-list-xs fill-height>
    <v-img class="background" src="/img/background-blur.jpg"></v-img>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 xl4>
        <v-card class="elevation-12">
          <v-toolbar color="#BBA981" dark flat>
            <v-toolbar-title>Connexion</v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <!-- Authentification user form -->
            <v-tabs v-model="tab" class="mb-5" background-color="transparent" color="basil" grow>
              <v-tab v-for="item in ['Traditionnelle', 'Code']" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-form>
                  <v-text-field label="Email" v-model="email" prepend-icon="mdi-account" type="text"/>
                  <v-text-field label="Mot de passe" v-model="api_key" prepend-icon="mdi-lock" type="password"/>
                </v-form>
              </v-tab-item>
              <v-tab-item>
                <v-form>
                  <v-text-field label="Code" v-model="code" prepend-icon="mdi-lock"/>
                </v-form>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="#BBA981" dark @click="loginSubmit"> Se connecter </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import moment from 'moment'
  
  /**
   * @brief Login view managing user authentification.
   * @bug No known bugs.
   */
  export default {
    data: () => ({
      email: null,
      api_key: '',
      code: '',
      tab: null,
      key: "JSMOEKWBCP"
    }),
    mounted() {
      window.localStorage.clear()
    },
    methods: {
      loginSubmit() {
        this.is_error = false
        if (this.tab) return this.loadGame()
        SAPIO.Loader.instance
          .logUser({ email: this.email, api_key: this.api_key })
          .then(() => {
            this.$notify({ group: 'app', type: 'info', title: 'Authentification réussie', text: 'Vous aller maintenant pouvoir accéder aux contenus' })
            this.$emit('refreshUser')
            this.$router.push('/')
          })
          .catch((e) => {
            this.$notify({ group: 'app', type: 'error', title: "Erreur lors de l'authentification", text: e.message })
            this.$emit('refreshUser')
            console.error(e)
          })
      },
      loadGame() {
        var scenarioId = this.checkCode()
        console.log(scenarioId)
        if (scenarioId === null) return
        SAPIO.Loader.instance
          .loadScenario(scenarioId)
          .then((scenario) => {
            var json = {...JSON.parse(scenario.json_data), ...scenario}
            delete json.json_data
            SAPIO.Scenario.createFromJson(json)
            SAPIO.Scenario.instance.LS_SAVE()
            SAPIO.Game.createFromJson({scenario_id: json.id, status:0, teamId: 0, currentStepIndex: -1, teamStates: {0: []}})
            SAPIO.Game.instance.LS_SAVE()
            this.$notify({ group: 'app', type: 'info', title: 'Scénario chargé !', text: 'Chargement de la partie' })

            if (scenario.is3d == 0) this.$router.push({ path: '/game' });
            else if (scenario.is3d == 1) this.$router.push({ name: 'gamecanvas', params: { map: scenario.map3d , code: this.code}})

            //this.$router.push('/game')
          })
          .catch((e) => {
            this.$notify({ group: 'app', type: 'error', title: 'Scénario introuvable', text: e.message })
            console.error(e)
          })
      },
      checkCode() {
        var scenarioIdConverted = parseInt(this.code.substring(0, this.code.length - 6).split('').map((x) => this.key.indexOf(x) + '').join(''))
        var endDateConverted = '20' + this.code.substring(this.code.length - 6).split('').map((x) => this.key.indexOf(x)).join('')
        
        endDateConverted = moment(endDateConverted, "YYYYMMDD")

        if (moment().isSameOrBefore(endDateConverted)) {
          return scenarioIdConverted
        } else {
          this.$notify({ group: 'app', type: 'error', title: 'Erreur', text: 'Le code est expiré' })
          return null
        }
      }
    },
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    height: auto;
    width: auto\9;
  }
  #spinner_container {
    text-align: center;
  }
  .spinner {
    margin: auto;
    margin: 4rem;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }
</style>
